import { client } from 'shared';

export interface IProgramType {
    id: number;
    name: string;
}

export function getProgramTypes(state: string): Promise<IProgramType[]> {
    const encodedState = encodeURIComponent(state);
    return client(`api/program-types/?state=${encodedState}`);
}
